import { ReactNode } from "react";
import { makeStyles, createStyles } from "@material-ui/core/styles";
import { Typography } from "@material-ui/core";

const useStyles = makeStyles(
  createStyles({
    overlay: {
      position: "relative",
      width: "100%",
      paddingTop: "56.25%",
      background: "#000",
      overflow: "hidden",
    },
    thumbnail: {
      position: "absolute",
      inset: 0,
      width: "100%",
      height: "100%",
      objectFit: "cover",
      opacity: 0.4,
    },
    content: {
      position: "absolute",
      inset: 0,
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      gap: 16,
      padding: 24,
      textAlign: "center",
    },
    message: {
      color: "#ffffff",
      fontFamily: "Open Sans",
    },
    allowButton: {
      background: "linear-gradient(180deg, #FFE600 0%, #FF8A00 100%)",
      padding: "10px 28px",
      borderRadius: 8,
      border: "none",
      cursor: "pointer",
      color: "#002F43",
      fontWeight: 700,
      fontFamily: "Cano, sans-serif",
      letterSpacing: 1,
      fontSize: 14,
    },
    watchLink: {
      display: "inline-flex",
      alignItems: "center",
      gap: 4,
      color: "#FFE600",
      textDecoration: "underline",
      fontFamily: "Open Sans",
      fontSize: 14,
    },
  }),
);

interface ConsentOverlayProps {
  /** URL of the thumbnail image shown in background */
  thumbnailUrl?: string;
  /** Alt text for the thumbnail image */
  thumbnailAlt?: string;
  /** Consent prompt message */
  message: string;
  /** External URL to open the content without cookies */
  watchUrl: string;
  /** Label for the external watch link */
  watchLabel: string;
  /** Icon rendered before the watch label */
  watchIcon: ReactNode;
  /** Called when user clicks "Accept Cookies" */
  onAllow: () => void;
}

/** Overlay shown over embedded video/media when cookie consent is missing. */
export default function ConsentOverlay({
  thumbnailUrl,
  thumbnailAlt = "Video thumbnail",
  message,
  watchUrl,
  watchLabel,
  watchIcon,
  onAllow,
}: ConsentOverlayProps) {
  const classes = useStyles();

  return (
    <div className={classes.overlay}>
      {thumbnailUrl && (
        <img
          src={thumbnailUrl}
          alt={thumbnailAlt}
          className={classes.thumbnail}
        />
      )}
      <div className={classes.content}>
        <Typography variant="body1" className={classes.message}>
          {message}
        </Typography>
        <button className={classes.allowButton} onClick={onAllow}>
          ACCEPT COOKIES
        </button>
        <a
          href={watchUrl}
          target="_blank"
          rel="noopener noreferrer"
          className={classes.watchLink}
        >
          {watchIcon}
          Or {watchLabel}
        </a>
      </div>
    </div>
  );
}
